/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ParcelsDto } from '../../models/parcels-dto';

export interface GetParcels$Params {
  parcel_pfi: Array<string>;
}

export function getParcels(
  http: HttpClient,
  rootUrl: string,
  params: GetParcels$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ParcelsDto>> {
  const rb = new RequestBuilder(rootUrl, getParcels.PATH, 'get');
  if (params) {
    rb.query('parcel_pfi', params.parcel_pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcelsDto>;
      }),
    );
}

getParcels.PATH = '/parcels';
